import React, { useEffect, useState } from 'react';
import liracrypt from '../../components/Liracrypt/liracrypt';
import { Modal, Spin, notification } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import FooterButtons from '../../components/STORM/FooterButtons';
import HModal from '../HModal';
import { useDispatch } from 'react-redux';
import Andon from '../LineDashboardZen/Andon/AndonPage';
import SessionError from '../../components/ApiErrorComp/SessionError';
import Angela1C from '../../components/ManagerDashboard/Common/Angela/Angela1C';
import { useSelector } from 'react-redux';


const MainLineGroupDashboard = (props) => {
    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
    const dispatch = useDispatch();
    const urlCode = useSelector(state => state.urlCode);
    const [andonModalTitle, setAndonModalTitle] = useState('');
    const [settingValues, setsettingValues] = useState(null);
    const [linedetails, setLineDetails] = useState();
    const [linegroupData, setLineGroupData] = useState();
    const [andonModal, setAndonModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [addonLoaded, setAddonLoaded] = useState(false);
    const [loginError, setLoginError] = useState(false);
    const [andonSettingValue, setAndonSettingValues] = useState();
    const [currentAndonLid, setCurrentAndonLid] = useState();
    const [selectedButton, setSelectedButton] = useState();
    const [action, setAction] = useState({});
    const [isHModalVisible, setIsHModalVisible] = useState(false);
    const [andonstatus, setAndonstatus] = useState(null);

    const [andonBlock, setAndonBlock] = useState(null);

    const getLineData = () => {
        liracrypt.get('/multilinedashboard', { dn: 'MultiLineDashboard', groupName: props.selectedGroupId })
            .then(response => {
                liracrypt.get('/multilinedashboard/linedashfixeddata', {
                    groupName: props.selectedGroupId
                }).then(({ data }) => {
                    console.log(data);
                    liracrypt
                        .get("/multilinedashboard/linedashvariabledata", {
                            groupName: props.selectedGroupId,
                        }).then((res) => {
                            setsettingValues(res.data.data);
                            setLineDetails(data.data);
                            setLineGroupData(response.data.data);
                            setLoading(false);
                        }).catch(err => {
                            console.log(err);
                        })

                }).catch(err => {
                    console.log(err);
                })
            }).catch(err => {
                console.log(err);
            })
    }

    useEffect(() => {
        let interval;
        if (andonModal) {
            return clearInterval(interval);
        }
        if (!linegroupData) {
            getLineData();
            setLoading(true);
        }
        interval = setInterval(() => {
            getLineData();
        }, 10000);
        return (() => clearInterval(interval));
    }, [andonModal]);

    const fetchAndonDetail = (lid, index) => {
        setAndonSettingValues({
            ...settingValues[index],
            ...linedetails[index]
        });
        setCurrentAndonLid(lid);
        setAndonModal(true);
        liracrypt
            .get("/linedashboard/andonstatus", { lid })
            .then(({ data }) => {
                dispatch({
                    type: 'andonStatus',
                    payload: {
                        andonColor: data.data.andonColor === 'G' ? 'Andon Green' :
                            data.data.andonColor === 'R' ? 'Andon Red' :
                                data.data.andonColor === 'O' ? 'Andon Orange' :
                                    data.data.andonColor === 'B' ? 'Andon Blue' :
                                        'Andon Green',
                        andonData: data.data
                    }
                });
                if (!andonstatus) {
                    setAndonstatus(data.data);
                    setAndonBlock(data.data.escDetails);
                } else {
                    setAndonstatus(data.data);
                }
                setAddonLoaded(true);
            })
            .catch(function (error) {
                // console.log("Error****:", error);
                if (error.response !== undefined) {
                    if (error.response.status !== 401) {
                        // ApiErrorComp(error.response.status);
                    } else {
                        setLoginError(true);
                    }
                }
            });
    };


    const finalAction = (action, res) => {
        if (action === "refreshPhantom") {
            notification.success({
                message: res?.data?.message
                    ? res?.data?.message
                    : "Data Modified Successfully !",
            });
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } else if (action === "refreshStable") {
            document.getElementById("submitButtonForm").click();
        } else {
            notification.success({
                message: res?.data?.message
                    ? res?.data?.message
                    : "Data Modified Successfully !",
            });
        }
    };

    const onResponse = ({ button, onlyPostSubmitAction, response }) => {

        // setStormResponse(data);
        let btnData = button || selectedButton;
        if (btnData.buttonProp?.popUpModal && !onlyPostSubmitAction) {
            return openPopupModal(btnData);
        };
        if (!btnData?.buttonProp?.postSubmitAction) {
            return;
        };
        // if (btnData?.postSubmitActionProp?.action === "clearForm") {
        //   form.resetFields();
        //   console.log("resetFields33");
        // }
        // if (btnData?.postSubmitActionProp?.action === "blankPage") {
        //   setStormResponse(null);
        // };
        if (btnData?.postSubmitActionProp?.action === "reloadStorm") {
            return document.getElementById("submitButtonForm").click();
        }
        if (btnData?.postSubmitActionProp?.action === "newTab") {
            return window.open(`/v02/${urlCode}` + btnData.postSubmitActionProp.route, '_blank');
        };

        if (btnData?.postSubmitActionProp?.action === 'reloadPage') {
            return window.location.reload();
        }
        finalAction(btnData?.postSubmitActionProp?.action, response)
    };

    const downloadDocs = (btn) => {
        // let button = btn || selectedButton;

        // if (selectedRowData.length <= 0) return;
        // selectedRowData.forEach(x => {
        //     document.getElementById('downloadLink').setAttribute("href", `${process.env.REACT_APP_API_ENDPOINT}${btn.fileDownload.api}?${btn.fileDownload.props}=${x[btn.fileDownload.props]}&token=${localStorage.getItem("token")}`);
        //     document.getElementById('downloadLink').click();
        // })
    }

    const openPopupModal = (button) => {
        setIsHModalVisible(true);
        setAction({ edit: button.popUpModalProp });
    };

    const onFinish = ({ button }) => {
        if (button?.submitFormDataProp?.method === 'POST') {
            let postData = { ...button?.submitFormDataProp.auxParam };
            //  postData.seldocs = selectedRowData;
            liracrypt.post(button?.submitFormDataProp.url, postData).then(response => {
                notification.success({ message: response.data.message });
                onResponse({ button, response })
            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong'
                    })
                })
        };
        if (button?.submitFormDataProp?.method === 'PATCH') {
            let postData = { ...button?.submitFormDataProp.auxParam };
            //  postData.seldocs = selectedRowData;
            liracrypt.patch(button?.submitFormDataProp.url, postData).then(response => {
                notification.success({ message: response.data.message });
                onResponse({ button, response })
            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong'
                    })
                })
        };

    };

    const handleAndonStatus = (updated) => {
        setAddonLoaded(false);
        if (updated === true) {
            fetchAndonDetail();
        } else {
            setAddonLoaded(true);
        }
    };

    const getBgColor = (andonColor) => {
        return andonColor === 'R' ? 'maintenence' :
            andonColor === 'G' ? 'run' :
                andonColor === 'O' ? 'runmode' :
                    andonColor === 'B' ? 'blue' :
                        ""
    }

    return (
        loading ? <div className='linegroup-loading'>
            <Spin indicator={<LoadingOutlined style={{ fontSize: 80 }} spin />} />
        </div> :
            linegroupData ?
                <div style={{ display: 'inline-flex', flexWrap: 'wrap', width: '100%' }}>
                    {
                        linegroupData.map((lineData, lineDataIndex) => (
                            <div key={lineDataIndex} className='linegroup-dashboard'>
                                <div className='linegroup-dashboard-header'>
                                    {
                                        lineData.header.map((item, index) => (
                                            <p key={index} style={item.style}>{item.text}</p>
                                        ))
                                    }
                                </div>
                                <div className='linegroup-dashboard-body' style={{ padding: 10 }}>
                                    <div className='linegroup-dashboard-angela' style={{ marginBottom: 10 }}>
                                        {
                                            lineData.angela.map((item, index) => (
                                                <Angela1C
                                                    key={index}
                                                    config={item}
                                                />
                                                // <div key={index} className="angela-block" style={{ border: '1px solid white', padding: 10, borderRadius: 10, overflow: 'hidden', marginRight: 10 }}>
                                                //     {
                                                //         item.headerBlocks.map((x, i) => (
                                                //             <div key={i} className='angela-header-block' style={x.style}>{x.text}</div>
                                                //         ))
                                                //     }
                                                //     {
                                                //         item.dataBlocks.map((x, i) => (
                                                //             <div key={i} style={x.style}>
                                                //                 {x.text}
                                                //             </div>
                                                //         ))
                                                //     }
                                                // </div>
                                            ))
                                        }
                                    </div>
                                    <div className="linegroup-dashboard-listing">
                                        {
                                            lineData.listing.map((listing, index) => (
                                                <div className="linegroup-listing-block" key={index + 'listing-wrapper'}>
                                                    {
                                                        listing.map((x, i) => (
                                                            <div key={i + 'listing-block'} className='listing-block' style={{ display: 'inline-flex', width: '100%' }}>
                                                                {
                                                                    x.content.map((line, __index) => (
                                                                        <p key={i + 'text'} style={line.style}>{line.text}</p>
                                                                    ))
                                                                }
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            ))
                                        }

                                    </div>
                                    <div
                                        className="LineContainer"
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            flex: "1 1 0%",
                                            flexDirection: "column"
                                        }}
                                    >
                                        {/* <div
                                        style={{
                                            fontWeight: 600,
                                            fontSize: 18,
                                            marginLeft: 2,
                                            color: "rgb(109, 109, 109)"
                                        }}
                                    >
                                        Andon Status
                                    </div> */}
                                        <div className='line-dashboard-zen' style={{ width: "100%", marginTop: 1, padding: 0 }}>
                                            <div className='Andon' style={{ width: "100%" }}>
                                                {" "}
                                                <p
                                                    className={`txtInfo andonStatus ${getBgColor(lineData?.andonStatus?.andonDict?.andonColor)}`}
                                                    style={{
                                                        borderRadius: 7,
                                                        marginBottom: 0,
                                                        minWidth: "100%",
                                                        color: "rgb(255, 255, 255)",
                                                        textAlign: "center",
                                                        backgroundColor: "rgb(59, 59, 59)",
                                                        fontSize: 20,
                                                        paddingTop: 5,
                                                        paddingBottom: 5,
                                                        fontWeight: 400,
                                                        display: "flex",
                                                        justifyContent: "center"
                                                    }}
                                                >
                                                    {lineData?.andonStatus?.andonDict?.pid?.val}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='linegroup-dashboard-btns' style={{ display: 'inline-flex', justifyContent: 'center', flexWrap: 'wrap', width: '100%' }}>
                                        {
                                            lineData.button.map((btn, i) => {
                                                const button = btn;
                                                if (button?.buttonProp?.visible) {
                                                    return (
                                                        <React.Fragment key={i}>
                                                            <FooterButtons
                                                                openAndonModal={() => {
                                                                    setAndonModalTitle(lineData.meta.lame);
                                                                    fetchAndonDetail(lineData.meta.lid, lineDataIndex)
                                                                }}
                                                                closeAndonModal={() => setAndonModal(false)}
                                                                downloadDocs={downloadDocs}
                                                                onFinish={onFinish}
                                                                postSubmitAction={onResponse}
                                                                openPopupModal={openPopupModal}
                                                                button={button}
                                                                setSelectedButton={setSelectedButton}
                                                                form={null}
                                                                label={button?.buttonProp?.label}
                                                                type={button?.buttonProp?.type}
                                                                disabled={!button?.buttonProp?.enable}
                                                                confirmationPopUp={button?.buttonProp?.confirmationPopUp ? button?.confirmationPopUpProp : undefined}
                                                                submitFormData={button?.submitFormDataProp}
                                                            />
                                                        </React.Fragment>
                                                    )
                                                }
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        ))
                    }


                    <Modal
                        title={andonModalTitle || 'Andon'}
                        open={andonModal}
                        style={{ minWidth: "1000px" }}
                        onCancel={() => {
                            setAndonModal(false);
                            setAddonLoaded(false);
                        }}
                        okText="Submit"
                        okButtonProps={{ loading: loading, hidden: true }}
                        cancelButtonProps={{ hidden: true }}
                    >
                        {addonLoaded ? (
                            <>
                                <SessionError visible={loginError} />
                                <div className='line-dashboard-zen'>
                                    <Andon
                                        onSubmit={() => {
                                            setLoading(true);
                                            getLineData();
                                            setAndonModal(false);
                                        }}
                                        settingValues={andonSettingValue}
                                        andonstatus={andonstatus}
                                        handleAndonStatusCallback={handleAndonStatus}
                                        selectedLid={currentAndonLid}
                                        andonBlock={andonBlock}
                                        lid={currentAndonLid}
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                <SessionError visible={loginError} />
                                <div className="Loading">
                                    <Spin indicator={antIcon} />
                                </div>
                            </>
                        )}
                    </Modal>

                    <HModal
                        submitBtnId={'submitBtnModal'}
                        //  barCode={barCode}
                        preventSubmitBtnClick={false}
                        onResponse={onResponse}
                        isModalVisible={isHModalVisible}
                        setIsModalVisible={setIsHModalVisible}
                        modalMethod={"edit"}
                        action={action}
                        modalData={null}
                        extraData={{}}
                    />
                </div> : <></>
    )
};

export default MainLineGroupDashboard;